/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 设置是否开启锁座判断
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  listenerLockCountDto: good.ListenerLockCountDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/good/lock-count`,
    data: listenerLockCountDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
